import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, getMyAuth } from 'src/app/store/app.state';
import { Utente } from '../models/utente.model';
import { take } from 'rxjs/operators';

/**Pure pipe che verifica se una voce di glossario è bloccabile/sbloccabile da parte dell'utente loggato */
@Pipe({
  name: 'lockableGlossary'
})
export class LockableGlossaryPipe implements PipeTransform {
  
  /**
   * Costruttore per la classe LockableGlossaryPipe
   * @param store {Store<AppState>} stato a livello dell'applicazione
   */
  constructor(private store: Store<AppState>) {}

  /**
   * Metodo dell'interfaccia PipeTransform
   * @param voceGlos {Glossary} voce di glossario per la quale effettuare la verifica (in realtà non usata)
   * @returns {boolean}
   */
  transform(voceGlos: any, ...args: any[]): any {
    let loggedUser: Utente;
    this.store.select(getMyAuth).pipe(take(1)).subscribe(data => {
      loggedUser = data.loggedUser;
    });
    if(loggedUser.type === 'Administrator' || loggedUser.type === 'Supervisor') {
      return true;
    } else {
      return false;
    }
  }

}
